export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 max-w-[1440px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-film-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                菲菲影院
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              菲菲影院提供高清不缓冲免费在线观看，流畅画质好电影电视剧全集，热播剧免费追剧在线看不卡顿，海量影视尽在菲菲影院。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              <a href="#ranking" className="hover:text-primary-400 transition-colors cursor-pointer">热门内容</a>
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">热播榜单</a></li>
              <li><a href="#carousel" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">焦点专题</a></li>
              <li><a href="#media" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">精彩预告</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">最新动态</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              <a href="#topics" className="hover:text-primary-400 transition-colors cursor-pointer">发现精彩</a>
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#topics" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">热门话题</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">精选推荐</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">专题合集</a></li>
              <li><a href="#app" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">手机追剧</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              <a href="#faq" className="hover:text-primary-400 transition-colors cursor-pointer">帮助与支持</a>
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">联系我们</a></li>
              <li><a href="#comments" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">用户评价</a></li>
              <li><a href="#features" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">平台优势</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800">
          <div className="mb-4">
            <h5 className="text-xs font-semibold text-background-500 mb-2">合作伙伴</h5>
            <p className="text-xs text-background-600">感谢所有合作伙伴的支持与信任</p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-600">
            <p>&copy; 2024 菲菲影院 版权所有</p>
            <p>高清不缓冲免费在线观看 · 海量影视尽在菲菲影院</p>
          </div>
        </div>
      </div>
    </footer>
  );
}